<!-- 故障报修 -->
<template>
  <div>
    <!-- 查询区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="工单编号">
              <a-input placeholder="请输入工单编号" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="报修人名称">
              <a-input placeholder="请输入报修人名称" v-model="queryParam.repairName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="报修状态">
              <a-select v-model="queryParam.repairState" placeholder="请选择报修状态">
                <a-select-option :value="1">审批中</a-select-option>
                <a-select-option :value="2">处理中</a-select-option>
                <a-select-option :value="3">处理结束</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="ticketsNum" slot-scope="text,record">
          <a-button type="primary" size="small" @click="onWork(record)" v-if="record.ticketsNum">{{ $t('工单详情') }}</a-button>
        </template>
        <template slot="repairState" slot-scope="text,record">
          <a-tag color="#c9c9c9" v-if="record.repairState==0">{{ $t('草稿') }}</a-tag>
          <a-tag color="#108ee9" v-if="record.repairState==1">{{ $t('审批中') }}</a-tag>
          <a-tag color="#87d068" v-if="record.repairState==2">{{ $t('处理中') }}</a-tag>
          <a-tag color="#f50" v-if="record.repairState==3">{{ $t('处理结束') }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <modal ref="modalForm"></modal>
  </div>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Modal from '@/views/OAoffice/faultRepairReport/modal.vue'
  import { postAction,getAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import Vue from 'vue'
  import { SYS_TYPE } from "@/store/mutation-types"
  import store from '@/store/'

  export default {
    name: 'WeChatApplicationRecord',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      Modal
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/wechatapply/wechatMeterRepair/list",
        },
        queryParam: {
          source: 1,
        },
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('工单信息'),
            align:"center",
            dataIndex: 'ticketsNum',
            scopedSlots: { customRender: 'ticketsNum' }
          },
          {
            title: this.$t('状态'),
            align:"center",
            dataIndex: 'repairState',
            scopedSlots: { customRender: 'repairState' }
          },
          {
            title: this.$t('报修人名称'),
            align:"center",
            dataIndex: 'repairName'
          },
          {
            title: this.$t('报修人电话'),
            align:"center",
            dataIndex: 'repairPhone',
          },
          {
            title: this.$t('报修地址'),
            align:"center",
            dataIndex: 'repairAddress',
          },
          {
            title: this.$t('报修描述'),
            align:"center",
            dataIndex: 'repairDescription',
          },
          {
            title: this.$t('报修时间'),
            align:"center",
            dataIndex: 'repairTime'
          },
          {
            title: this.$t('处理人'),
            align:"center",
            dataIndex: 'wechatHandleUserName'
          },
          {
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'wechatHandleUserTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.source = 1;
        params.userId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      searchReset(){
        this.queryParam = {
          source: 1
        }
        this.loadData();
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row);
        });
      },
      // 跳转工单记录
      onWork(row){
        Vue.ls.set(SYS_TYPE,8);
        store.commit('SET_SYSTYPE', 8);
        this.$router.replace({ path: "/workOrderManagement/workManagement/index",query:{ticketsNum:row.ticketsNum} });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>